import { render } from "./facturation_tab.vue?vue&type=template&id=6b620fe6"
import script from "./facturation_tab.vue?vue&type=script&lang=js"
export * from "./facturation_tab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__